import './global/jquery-migrate';
import './common/select-option-plugin';
import PageManager from './page-manager';
import initPayPalPayLater from './global/paypal-pay-later';

function loadDefault(importer, ...args) {
    return importer().then(({ default: init }) => init(...args));
}

export default class Global extends PageManager {
    onReady() {
        const isMobile = /Mobi/i.test(navigator.userAgent);

        initPayPalPayLater();

        loadDefault(() => import('./global/foundation'), $(document));
        loadDefault(() => import('./global/cart-preview'), this.context.secureBaseUrl, this.context.cartId, this.context.disableMinicart, this.context.enableSideCart);

        if ($('#quickSearch').length) {
            loadDefault(() => import('./global/quick-search'));
        }

        if ($('.currencySelector').length) {
            loadDefault(() => import('./global/currency-selector'));
        }

        if ($('.quickview').length) {
            loadDefault(() => import('./global/quick-view'), this.context);
        }

        if ($('[data-slick]').length) {
            loadDefault(() => import('./common/carousel'));
        }

        if ($('[data-mobile-menu-toggle]').length) {
            loadDefault(() => import('./global/mobile-menu-toggle'));
        }

        if ($('.js-quick-add').length) {
            loadDefault(() => import('./f/quick-add-sku'));
        }

        if ($('[data-cart-item-add-from-card]').length) {
            loadDefault(() => import('./f/card-add-to-cart'));
        }

        if ($('[data-account-menu]').length) {
            loadDefault(() => import('./f/account-menu'));
        }

        if ($('input[type=tel]').length) {
            loadDefault(() => import('./f/auto-highlight'));
        }

        if ($('svg[data-src]').length) {
            loadDefault(() => import('./global/svg-injector'));
        }

        if (this.context.maintenanceMode && (this.context.maintenanceMode.header || this.context.maintenanceMode.notice)) {
            loadDefault(() => import('./global/maintenanceMode'), this.context.maintenanceMode);
        }

        loadDefault(() => import('./global/loading-progress-bar'));

        if (!isMobile && this.context.enableRecentSellers) {
            loadDefault(() => import('./f/recent-sellers'), this.context.recentSellersTimer, this.context.recentSellersHideAfter, this.context);
        }

        if (!isMobile && this.context.enableHoverNavigation) {
            loadDefault(() => import('./f/hover-navigation'));
        } else {
            loadDefault(() => import('./global/menu'));
        }

        if (window.ApplePaySession) {
            $('.apple-pay-checkout-button').show();
        }
    }
}
